//
/**
 * 设置cookie
 * @param {[type]} key   [键名]
 * @param {[type]} value [键值]
 * @param {[type]} days  [保存的时间（天）]
 */
function setCookies (key, value) {
  // 设置过期原则
  if (!value) {
    localStorage.removeItem(key)
  } else {
    var exp = new Date()
    localStorage[key] = JSON.stringify({
      value,
      expires: exp.getTime() + 1000 * 60 * 60 * 24 * 3
    })
  }
}
function getCookies (name) {
  try {
    let o = JSON.parse(localStorage[name])
    if (!o || o.expires < Date.now()) {
      return null
    } else {
      return o.value
    }
  } catch (e) {
    // 兼容其他localstorage
    return localStorage[name]
  } finally {
  }
}


let xieyi = "https://"
if (window.location.href.indexOf("https://") > -1) {
  xieyi = "https://"
}

// let url='http://192.168.110.230:8658';
let url = xieyi + "adx.tangelo.com.cn:8658";
if(window.location.hostname.indexOf("tangelo")>-1){
  url= xieyi + "adx.tangelo.com.cn:8658";
}else if(window.location.hostname.indexOf("otthink")>-1){
  url="http://ksadx.otthink.cn:8658";
}else{
  url="http://localhost:8658";
}

export default{
  state: {
    token: getCookies('mediaToken'),
    userData: {},
    uid: 0,
    notic: 0,
    username: getCookies('mediaUsername'),
    shownoc: false,
    // mediaUrl: 'http://180.76.178.250:8058',
    // mediaUrl: 'http://180.76.112.188:8058',
    // mediaUrl: 'http://localhost:8058',
    mediaUrl:url
    // tempUrl: 'http://localhost:8058',
    // tempUrl: 'http://180.76.178.250:8058',
    // tempUrl: 'http://180.76.112.188:8058',

  },
  getters: {
    token: state => state.token,
    getToken: (state) => {
      return getCookies('mediaToken')
    },
    getUsername: (state) => {
      return getCookies('mediaUsername')
    },
    getNotic: (state) => {
      return state.notic
    },
    getUid: (state) => {
      if(state.uid==0){
        return getCookies('mediaUid')
      }else{
        return state.uid;
      }

      //return getCookies('mediaUid')
    }
  },
  mutations: {
    setUserData: (state, payload) => {
      state.userData = payload
      state.username = payload.username
      setCookies('mediaUsername', payload.username)
      setCookies('mediaCompany', payload.company)
      setCookies('myUserData', payload)
    },
    setToken: (state, payload) => {
      state.token = payload
      setCookies('mediaToken', payload)
    },
    setNotic: (state, notic) => {
      state.notic = notic
    },
    setUid: (state, uid) => {
      state.uid = uid
      setCookies('mediaUid', uid)
    },
    logout: () => {
      setCookies('mediaUsername', null)
      setCookies('mediaToken', null)
    }
  },
  actioins: {
  }
}



// WEBPACK FOOTER //
// ./src/store/Store.js